module.exports = __webpack_public_path__ + "banquet/components/StoreAboutPage/images/about_email_3x.9c29e64ce0587844b57ae30acaa91147.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreAboutPage/images/about_email_3x.png
// module id = 1692
// module chunks = 1